<template>
    <rkm-form
        ref="Form"
        show-legend
        v-if="model"
    >
        <FormCadastro
            :data="{ form, model }"
            :id="id"
        />

        <FormProfissional
            :data="{ form, model }"
            :id="id"
            @profissionais="profissionais"
        />

       <FormAtividade
            :data="{ form, model }"
            :id="id"
        />

        <FormReuniao
            :data="{ form, model }"
            :id="id"
        />

        <FormPublico
            :data="{ form, model }"
            :id="id"
        />

        <FormTema
            :data="{ form, model }"
        />

        <FormPratica
            :data="{ form, model }"
            :id="id"
        />

        <FormParticipante
            :data="{ form, model }"
            :id="id"
        />

        <rkm-area
            type="fieldset"
            title="Procedimentos"
            class="mt-3"
        >
            <rkm-button
                @click="$refs.ModalProcedimento.open()"
                color="primary"
                slot="trailing"
                small
                title="Adicionar"
            >
                <rkm-icon icon="plus" />
            </rkm-button>

            <FormProcedimento
                :data="{ form, model }"
                :id="id"
            />
        </rkm-area>

        <TableParticipante
            :data="{ form, model }"
            :id="id"
            @procedimentosIndividuais="procedimentosIndividuais"
        />

        <ModalProcedimento
            :data="{ form, model }"
            ref="ModalProcedimento"
        />
    </rkm-form>
</template>

<script>
// Vuex.
import { mapActions } from "vuex";

// Mixins
import { repository, stringCase, data, object, formats, error, unmask } from "@/mixins";

import moment from "moment";

// Components
import FormCadastro from './components/cadastro/Form.vue'
import FormProfissional from './components/profissional/Form.vue'
import FormAtividade from './components/atividade/Form.vue'
import FormReuniao from './components/reuniao/Form.vue'
import FormPublico from './components/publico/Form.vue'
import FormTema from './components/tema/Form.vue'
import FormPratica from './components/pratica/Form.vue'
import FormParticipante from './components/participante/Form.vue'
import FormProcedimento from './components/procedimento/Form.vue'
import TableParticipante from './components/participante/Table.vue'
import ModalProcedimento from './components/procedimento/Modal'

export default {
    components: {
        FormCadastro,
        FormProfissional,
        FormAtividade,
        FormReuniao,
        FormPublico,
        FormTema,
        FormPratica,
        FormParticipante,
        FormProcedimento,
        TableParticipante,
        ModalProcedimento
    },
    computed: {

    },
    created() {

        this.repositories = {
            atividadeColetiva: this.getConectaSusRepository('atencaoBasica.atividadeColetiva'),
            logradouro: this.getConectaSusRepository('cadastro.localizacao.logradouro')
        },

        this.load();
    },
    data: () => ({
        model: null,
        form: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        async validate() {

            return this.$refs.Form.validate()
        },
        procedimentosIndividuais(procedimentos) {
            this.model.procedimentosIndividuais = procedimentos
        },
        profissionais(profissionais) {
            this.model.profissionais = profissionais
        },
        load() {

            this.setLoading()

            if(this.id) {
                this.repositories.atividadeColetiva.edit(this.id)
                    .then(({ data }) => {

                        this.model = Object.assign(data.model)
                        this.form = Object.assign(data.form)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.atividadeColetiva.create()
                    .then(({ data }) => {

                        this.model = Object.assign(data.model)
                        this.form = Object.assign(data.form)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {

            this.$refs['Form'].validate()
                .then(valid => {

                if (!valid) return

                    this.setLoading()

                    this.repositories.atividadeColetiva.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
            })
        },
        prepareData() {

            const id = this.id

            this.model.cadastro.dataCadastro = moment(this.model.cadastro.dataCadastro).format("Y-M-D");

            const atividade = this.clone(this.model.atividade)
            const cadastro = this.clone(this.model.cadastro)
            const participantes = this.clone(this.model.participantes)
            const procedimentos = this.clone(this.model.procedimentos)
            const procedimentosIndividuais = this.clone(this.model.procedimentosIndividuais)
            const profissional = this.clone(this.model.profissional)
            const profissionais = this.clone(this.model.profissionais)

            const procedimentoColetivoId = this.clone(this.model.procedimentoColetivoId)

            const reuniaoTemas = this.clone(this.model.reuniaoTemas)
            const publicoAlvo = this.clone(this.model.publicoAlvo)
            const saudeTemas = this.clone(this.model.saudeTemas)
            const saudePratica = this.clone(this.model.saudePratica)

            delete(cadastro.usuario)

            return this.camelObjectKeysToSnakeRecursive({
                id, atividade, cadastro, participantes,
                procedimentos, procedimentosIndividuais,
                profissional, profissionais, procedimentoColetivoId,
                reuniaoTemas, publicoAlvo, saudeTemas, saudePratica
            })
        },
    },
    mixins: [ repository, stringCase, data, object, formats, error, unmask ],
    props: {
        id: { type: Number }
    }
}
</script>